<template>
    <div>
    <UnAuthMenuBar />
    <v-row justify="center">
    <div style="display:flex;min-width:100%;justify-content:center">
        <h4 style='font-weight:600; text-decoration:underline'>Frequently Asked Questions</h4>
    </div>

    <v-expansion-panels popout>
      <v-expansion-panel
        v-for="(q,i) in questionsList"
        :key="i"
      >
        <v-expansion-panel-header style ='font-size: 18px; font-style: bold;'>{{q.Q}}</v-expansion-panel-header>
        <v-expansion-panel-content style ='font-size: 18px;'>
          <span v-html="q.A" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
  </div>
</template>

<script>
import Vue from 'vue';
import questions from "@/config/faq.json";
import UnAuthMenuBar from "@/components/UnAuthMenuBar.vue";

export default Vue.extend({
  name: 'Faq',
  components: {
    UnAuthMenuBar
  },
  computed: {
    questionsList(){
      return questions
    }
  }

})


</script>

<style scoped src="@/assets/css/faq.css">
</style>

<style scoped src="@/assets/css/fonts.css">
</style>


